import Const from 'const';

export function getModeSlatesFromSlatesPayload(slatesPayload: object, mode: string): object[] {
    const sectionsMap = {
        [Const.MODE_MAIN]: 'scheduled',
        [Const.MODE_BACKTEST]: 'archived',
        [Const.MODE_LATESWAP]: 'lateswap',
    };

    return sectionsMap[mode] in slatesPayload ? slatesPayload[sectionsMap[mode]] : [];
}

export function getAllSlateIdsFromSlatesPayload(slatesPayload: object): number[] {
    const slateIds: number[] = [];
    Object.values(slatesPayload).map((modeSlates) => {
        // @ts-ignore
        Object.values(modeSlates).map((slate) => slateIds.push(slate.id));
    });

    return slateIds;
}
